module.exports = __webpack_public_path__ + "static/media/adv-1.33f00dca.png";